import { ColumnsType } from "antd/es/table/interface";
import { EditOutlined } from "@ant-design/icons";
import { UserManagement, Role } from "../../../../types/user-management";

export const UsersTableColumns = (onUserSelected: any): ColumnsType<UserManagement> => {
  let columns: ColumnsType<UserManagement> = [
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
      width: "10%"
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
      width: "10%"
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "20%"
    },
    {
      title: "Roles",
      dataIndex: "roles",
      key: "roles",
      width: "20%",
      render: (roles: Role[]) => (
        <ul>
          {roles.map((role) => (
            <li key={role.id}>{role.name}</li>
          ))}
        </ul>
      )
    },
    {
      title: "Actions",
      dataIndex: "id",
      key: "id",
      width: "3%",
      render: (id) => (
        <EditOutlined
          onClick={() => {
            onUserSelected(id);
          }}
          style={{ fontSize: "1.2rem", cursor: "pointer" }}
        />
      )
    }
  ];
  return columns;
};
